const Break = {
  print: () => 'break'
};

module.exports = Break;
